import { styled } from "@mui/material/styles";
import { Box, Button, Chip, Typography, Checkbox } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const ChipActive = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#4caf50",
    border: "1px solid #4caf50",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
  },
});

export const ChipInactive = styled(Chip)({
  "&.MuiChip-root": {
    backgroundColor: "transparent",
    color: "#999",
    border: "1px solid #999",
    borderRadius: "16px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    height: "24px",
  },

  "& .MuiChip-label": {
    padding: "0 6px",
    fontSize: "13px",
    fontWeight: 400,
    letterSpacing: "0.16px",
    color: "#999",
  },
});

export const Container = styled(Box)({
  background: "white",
  borderRadius: "4px",
  padding: "24px",
  marginTop: "15px",
});

export const Header = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  padding: "8px 8px 8px 16px",
  marginBottom: "16px",
});

export const PaymentOptions = styled("div")({
  display: "flex",
  width: "90%",
  paddingLeft: "16px",
  flexWrap: "wrap",
  justifyContent: "space-between",
  marginBottom: "16px",
});

export const PaymentOption = styled("div")({
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
});

export const CardFlags = styled("div")({
  display: "flex",
  gap: "4px",
});

export const CardFlag = styled("img")({
  width: "36px",
  height: "24px",
  borderRadius: "5.5px",
  background: "#f6f7fc",
});

export const ActionsContainer = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
  boxSizing: "border-box",
  paddingTop: "24px",
  gap: "8px",
});

export const ButtonPrimary = styled(Button)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "auto",
  padding: "6px 16px",
  height: "36px",
  borderRadius: "40px",
  cursor: "pointer",
  color: "#000000",
  gap: "6px",
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 500,

  "&:hover": {
    background: "transparent",
    border: "1px solid rgba(0, 0, 0, 0.5)",
  },
});

export const CancelButton = styled(Button)({
  width: 120,
  height: 40,
  borderRadius: "40px",
  borderColor: "rgba(0, 0, 0, 0.5)",
  color: "#000000",
  textTransform: "uppercase",
  fontSize: "14px",
  fontWeight: 500,
  "&:hover": {
    backgroundColor: "transparent",
    borderColor: "rgba(0, 0, 0, 0.5)",
  },
});

export const HeaderCaption = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  letterSpacing: "0.4px",
});

export const PaymentOptionContent = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const CheckCircleIconStyled = styled(CheckCircleIcon)<{
  enabled: boolean;
}>(({ enabled }) => ({
  color: enabled ? "#4CAF50" : "rgba(0, 0, 0, 0.26)",
  fontSize: "20px",
}));

export const MethodDescription = styled(Typography)<{ enabled: boolean }>(
  ({ enabled }) => ({
    fontSize: "16px",
    fontWeight: 400,
    letterSpacing: "0.15px",
    color: enabled ? "rgba(0, 0, 0, 0.87)" : "rgba(0, 0, 0, 0.38)",
  }),
);

export const EditButton = styled(Button)({
  backgroundColor: "#D33100",
  color: "#FFFFFF",
  borderRadius: "40px",
  fontSize: "15px",
  fontWeight: 500,
  letterSpacing: "0.46px",
  textTransform: "uppercase",
  height: 40,
  padding: "0 22px",
  boxShadow:
    "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: "#D33100",
  },
});

export const ApplyButton = styled(Button)({
  backgroundColor: "#D33100",
  color: "#FFFFFF",
  borderRadius: "40px",
  fontSize: "15px",
  fontWeight: 500,
  letterSpacing: "0.46px",
  textTransform: "uppercase",
  height: 40,
  padding: "0 22px",
  boxShadow:
    "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: "#D33100",
  },
});

export const MethodsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const MethodContainer = styled(Box)({});

export const BrandsContainer = styled(Box)({
  marginTop: "16px",
  marginLeft: "40px",
});

export const BrandsTitle = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  letterSpacing: "0.4px",
  marginBottom: "8px",
  display: "block",
});

export const BrandsList = styled(Box)({
  display: "flex",
  gap: "18px",
  flexWrap: "wrap",
});

export const CheckboxPrimary = styled(Checkbox)({
  color: "#D33100",
  "&.Mui-checked": {
    color: "#D33100",
  },
});

export const CheckboxPrimarySmall = styled(Checkbox)({
  color: "#D33100",
  "&.Mui-checked": {
    color: "#D33100",
  },
});

export const MethodLabel = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  letterSpacing: "0.15px",
});

export const BrandLabel = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  letterSpacing: "0.17px",
});

export const BrandIconImage = styled("img")({
  height: "24px",
  width: "auto",
});
